module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-3-efc3b0f02c73fce753b5d8b158530fd5.svg";